import {ImageSelectOption} from "../components/ImageGroupSelect";
import {Brand, CableTrayType, HouseType, PlacementOutside, RoomType, WallType} from "./enums";
import {
    aluminium,
    appartement,
    appartementGroot,
    attic,
    bedroom,
    cellar,
    concrete,
    concreteGroot,
    crepi,
    crepiGroot,
    design,
    emptyroom,
    facadehigh,
    facadelow,
    flatroof,
    galvanized,
    garage,
    geslotenbebouwing,
    geslotenbebouwingGroot,
    ground,
    halfopenbebouwing,
    halfopenbebouwingGroot,
    livingroom,
    noclue,
    openbebouwing,
    openbebouwingGroot,
    quickbuild,
    quickbuildGroot,
    roof,
    standard,
    woodenskeleton,
    woodenskeletonGroot
} from "../images";
import {ButtonSelectOption} from "../components/ButtonGroupSelect";

export const houseTypesOptions: ImageSelectOption[] = [{key: HouseType.open, name: 'Open bebouwing', src: openbebouwing, srcBig: openbebouwingGroot}, {key: HouseType.halfopen, name: 'Halfopen bebouwing', src: halfopenbebouwing, srcBig: halfopenbebouwingGroot}, {key: HouseType.closed, name: 'Gesloten bebouwing', src: geslotenbebouwing, srcBig: geslotenbebouwingGroot}, {key: HouseType.apartment, name: 'Appartement' , src: appartement, srcBig: appartementGroot}];
export const placementOutsideOptions: ImageSelectOption[] = [{key: PlacementOutside.ground, name: 'Grond', src: ground}, {key: PlacementOutside.flatRoof, name: 'Plat dak (<3m)', src: flatroof}, {key: PlacementOutside.facadeLow, name: 'Gevel (<2.5m)', src: facadelow}, {key: PlacementOutside.facadeHigh, name: 'Gevel (>2.5m)', src: facadehigh}, {key: PlacementOutside.roof, name: 'Dak (>3m)', src: roof}];
export const wallTypeOptions: ImageSelectOption[] = [{key: WallType.concrete, name: 'Beton', src: concrete, srcBig: concreteGroot}, {key: WallType.quickBuild, name: 'Baksteen', src: quickbuild, srcBig: quickbuildGroot}, {key: WallType.woodenSkeleton, name: 'Houtskelet', src: woodenskeleton, srcBig: woodenskeletonGroot}, {key: WallType.crepi, name: 'Crepi', src: crepi, srcBig: crepiGroot}, {key: WallType.noClue, name: 'Geen idee', src: noclue}];
export const cableTrayOptions: ImageSelectOption[] = [{key: CableTrayType.standard, name: 'Standaard', src: standard}, {key: CableTrayType.design, name: 'Design grijs, zwart of wit', src: design}, {key: CableTrayType.galvanized, name: 'Gegalvaniseerd', src: galvanized}, {key: CableTrayType.aluminium, name: 'Aluminium', src: aluminium}, {key: CableTrayType.noClue, name: 'Geen idee', src: noclue}];
export const roomTypes: ImageSelectOption[] = [{key: RoomType.bedroom, name: 'Slaapkamer', src: bedroom}, {key: RoomType.livingroom, name: 'Woonkamer', src: livingroom}, {key: RoomType.garage, name: 'Garage', src: garage}, {key: RoomType.cellar, name: 'Kelder', src: cellar}, {key: RoomType.attic, name: 'Zolder', src: attic}, {key: RoomType.other, name: 'Overig', src: emptyroom}];
export const floorTypes: ButtonSelectOption[] = [{key: -1, name: 'Kelderverdieping'}, {key: 0, name: 'Gelijkvloers'}, {key: 1, name: '1ste verdieping'}, {key: 2, name: '2e verdieping'}, {key: 3, name: '3e verdieping'}, {key: 4, name: '4e verdieping'}];
export const insideUnitTypes: {[key in Brand]: ImageSelectOption[]} = {
    LG: [
        {key: 'default', name: 'SP', showName: 'Standaard Plus', src: '/images/lg-unit-default.png'}, // standaard plus
        {key: 'deluxe', name: 'DE', showName: 'Deluxe', src: '/images/lg-unit-deluxe.png'},
        {key: 'artcool', name: 'AZ', showName: 'Artcool', src: '/images/lg-unit-artcool.png'},
        {key: 'artcool-silver', name: 'AZ', showName: 'Artcool Zilver', src: '/images/lg-unit-artcool-silver.png'},
        // {key: 'artcool-gallery', name: '', src: '/images/lg-unit-artcool-gallery.png'},
    ],
    Daikin: [
        {key: 'default', name: 'PE', showName: 'Perfera', src: '/images/daikin-unit-default.png'}, // mural perfera
        {key: 'comfora', name: 'CO', showName: 'Comfora', src: '/images/daikin-unit-comfora.png'},
        {key: 'stylish-silver', name: 'SK', showName: 'Stylish Zilver', src: '/images/daikin-unit-stylish-silver.png'},
        {key: 'stylish-zwarthout', name: 'SK', showName: 'Stylish Zwarthout', src: '/images/daikin-unit-stylish-zwarthout.png'},
        {key: 'stylish-white', name: 'SW', showName: 'Stylish Wit', src: '/images/daikin-unit-stylish-white.png'},
        {key: 'emura-wit', name: 'EW', showName: 'Emura Wit', src: '/images/daikin-unit-emura-wit.png'},
        {key: 'emura-silver', name: 'EZ', showName: 'Emura Zilver', src: '/images/daikin-unit-emura-silver.png'},
    ]
}